import {customElement} from 'lit/decorators.js';
import {of} from 'rxjs';
import {FilterView} from './filter-view';
import {ri} from './runner-idle';
import {Spell} from './spell';
import {any$} from './utils';

@customElement('ri-spells')
export class Spells extends FilterView {
  override id = 'spells';
  override name = 'Spells';
  override displayName = 'Spells';
  override subtitle =
    'Click to manual cast, shift-click or drag to add to queue.';
  override isIntersection = true;
  override possibleFilters = new Set([
    {name: 'lightMagic', displayName: 'Light'},
    {name: 'fireMagic', displayName: 'Fire'},
    {name: 'timeMagic', displayName: 'Time'},
    {name: 'spaceMagic', displayName: 'Space'},
    {name: 'crystalMagic', displayName: 'Crystal'},
    {name: 'combat', displayName: 'Combat'},
  ]);
  override replacementEntryTag = 'ri-spell';

  constructor() {
    super();
    this.unlock$ = any$(Object.values(ri.spells).map((spell) => spell.unlock$));
    this.filterables$ = of(Object.values(ri.spells));
    // realtime spells (mostly Time Magic) cooldown according to irl time,
    // while others cooldown based on game time.
    let lastTime = 0;
    const loop = (now: number) => {
      if (!lastTime) lastTime = now;
      // TODO TEMP
      // for (const spell of this.filterables.filter((spell) =>
      //   spell.tags.has('realtime')
      // )) {
      //   spell.currentCooldown = spell.currentCooldown.minus(
      //     (now - lastTime) / 1000
      //   );
      // }
      lastTime = now;
      requestAnimationFrame(loop);
    };
    requestAnimationFrame(loop);
  }
}
